import VideoPlayer from './../shared/videoPlayer';
import { setCookie, getCookie } from './../shared/cookieHelper';

const builderSpecVideoGenerationTimeout = 300; //in seconds

$(function () {
    if ($('#speclock_confirmation_page').length) {
        $(document).ready(function () {
            var $loading = $('#ll_loading-div').hide();
            var button = $('#attach-button');
            var input = $('#attach-input');
            var logobutton = $('#logo-attach-button');
            var logoinput = $('#logo-attach-input');
            var form = new FormData();
            form.append("loan-number", $("#loan-number").val());

            $("#new_builder_phonenumber").inputmask("(999) 999-9999", { clearIncomplete: true });

            var loc1 = getCookie("speclock_prefix_url");

            var exist = $("#hdnNoExist").val();
            $("#fico-div").hide();
            $("#featured-button-div").hide();

            if (!exist) {
                $.ajax({
                    url: 'generate-flyer-confirmation',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $("#openimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                    },
                    success: function (response) {
                        if (response != "") {
                            response = response.replace("/upload/", "/upload/fl_attachment:OpenFlyer/")
                            $("#openlink").attr("href", response);
                            $("#openimg").attr("src", response.replace(".pdf", ".png"));
                        }
                    }
                });

                $.ajax({
                    url: 'generate-flyer-speclock',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $("#slopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                    },
                    success: function (response) {
                        if (response != "") {
                            response = response.replace("/upload/", "/upload/fl_attachment:PromoFlyer/")
                            $("#slopenlink").attr("href", response);
                            $("#slopenimg").attr("src", response.replace(".pdf", ".png"));
                        }
                    }
                });
                $.ajax({
                    url: 'generate-builder-socialPMT',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $("#socialpmtopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                    },
                    success: function (response) {
                        if (response != "") {
                            response = response.replace("/upload/", "/upload/fl_attachment:SocialPost/")
                            $("#socialpmtopenlink").attr("href", response);
                            $("#socialpmtopenimg").attr("src", response.replace(".pdf", ".png"));
                        }
                    }
                });

                $.ajax({
                    url: 'generate-featured-rate-post',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $("#educationpostimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                    },
                    success: function (response) {
                        if (response != "") {
                            response = response.replace("/upload/", "/upload/fl_attachment:FeaturedRatePost/")
                            $("#educationpostlink").attr("href", response);
                            $("#educationpostimg").attr("src", response.replace(".pdf", ".png"));
                        }
                    }
                });

                var formnew = new FormData();
                formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", $("#hdnLP").val());
                LoadDownpayments(formnew);
            }

            $('#new-loanprogram').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                var textSelected = optionSelected.text()

                var formnew = new FormData();
                formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", textSelected);

                LoadDownpayments(formnew);
            });

            function LoadDownpayments(formnew)
            {
                $.ajax({
                    url: 'get-downpayments-for-loanprogram',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formnew,
                    beforeSend: function () {
                        $("#loading-img-featured").removeClass("d-none");
                    },
                    success: function (response) {
                        $("#loading-img-featured").addClass("d-none");
                        if (response.success) {
                            $('#new-downpayment').empty();
                            $('#new-downpayment').append(new Option("-select-", ""));
                            for (var i = 0; i < response.data.length; i++) {
                                $('#new-downpayment').append(new Option((response.data[i] * 100).toFixed(2).toString(), response.data[i]));
                            }
                        }
                    }
                });
            }

            $('#new-downpayment').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                var textSelected = optionSelected.text()

                var formnew = new FormData();
                formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", $("#new-loanprogram").val());
                formnew.append("down-payment", valueSelected);

                $.ajax({
                    url: 'get-ficoscores-for-loanprogram',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formnew,
                    beforeSend: function () {
                        $("#loading-img-featured").removeClass("d-none");
                    },
                    success: function (response) {
                        $("#loading-img-featured").addClass("d-none");
                        if (response.success) {
                            $("#fico-div").show();
                            $("#featured-button-div").show();
                            $('#new-fico').empty();
                            $('#new-fico').append(new Option("-select-", ""));
                            for (var i = 0; i < response.data.length; i++) {
                                $('#new-fico').append(new Option(response.data[i].key, response.data[i].value));
                            }
                        }
                    }
                });
            });

            $('#new-fico').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                var textSelected = optionSelected.text()

                var formnew = new FormData();
                formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", $("#new-loanprogram").val());
                formnew.append("down-payment", $('#new-downpayment option:selected').val());
                formnew.append("fico-scores", textSelected);

                $.ajax({
                    url: 'get-loan-program-code',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formnew,
                    beforeSend: function () {
                        $("#loading-img-featured").removeClass("d-none");
                    },
                    success: function (response) {
                        $("#loading-img-featured").addClass("d-none");
                        if (response.success) {
                            $("#hdnloanprogramcode").val(response.data);
                        }
                    }
                });
            });

            function BuildFormData(files) {
                var data = new FormData();
                data.append("loan-number", $("#loan-number").val());

                for (var i = 0; i < files.length; i++) {
                    data.append(files[i].name, files[i]);
                }

                return data;
            }

            function PostData(url, data) {
                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#instructions-div p').removeClass('upload-error');

                        $('[download="CustomVideo"], [download="VideoQRCode"]').parent().addClass('d-none');
                        $('#instructions-div p').text('Please wait while we generate your customized property video. It might take up to 5 minutes');
                        $('#instructions-div').removeClass('d-none');

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').addClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').removeClass('d-none');

                        $('#instructions-edu-div p').removeClass('upload-error');

                        $('[download="CustomVideo1"]').parent().addClass('d-none');
                        $('#instructions-edu-div p').text('Please wait while we generate your customized property video. It might take up to 5 minutes');
                        $('#instructions-edu-div').removeClass('d-none');

                        $('#educational_video_placeholder, #educational_video').addClass('d-none');
                        $('#educational_video_loading').removeClass('d-none');

                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            window.location.href = window.location.origin + window.location.pathname + '?id=' + $("#loan-number").val();
                            return;
                        }

                        console.log(result.error);

                        $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');

                        $('#instructions-edu-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                        $('#educational_video_placeholder, #educational_video').removeClass('d-none');
                        $('#educational_video_loading').addClass('d-none');
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log("Status: " + textStatus); alert("Error: " + errorThrown);

                        $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');
                        $('#instructions-edu-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');

                        $('#educational_video_placeholder, #educational_video').removeClass('d-none');
                        $('#educational_video_loading').addClass('d-none');
                    }
                });
            }

            button.on('click', function (e) {
                e.preventDefault();
                input.click();
            });

            logobutton.on('click', function (e) {
                e.preventDefault();
                logoinput.click();
            });

            input.on('change', function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-listing-image';

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $("#listing-image-form").addClass("d-none");
                        $("#form-listing-image").addClass("d-none");
                        $("#loading-img-listing").removeClass("d-none");
                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            window.location.href = window.location.origin + window.location.pathname + '?id=' + $("#loan-number").val();
                            return;
                        }

                        console.log(result.error);
                        $("#form-listing-image").removeClass("d-none");
                        $("#listing-image-form").removeClass("d-none");
                        $("#loading-img-listing").addClass("d-none");
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log("Status: " + textStatus); alert("Error: " + errorThrown);

                        $('#loading-builderlogo').addClass('d-none');
                    }
                });
            });

            logoinput.on('change', function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-builder-logo';

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#loading-builderlogo').removeClass('d-none');
                        $("#builder-logo-form").addClass("d-none");
                    },
                    success: function (result) {
                        if (result.success) {
                            window.location.href = window.location.origin + window.location.pathname + '?id=' + $("#loan-number").val();
                            return;
                        }

                        console.log(result.error);
                        $("#builder-logo-form").removeClass("d-none");
                        $('#loading-builderlogo').addClass('d-none');
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log("Status: " + textStatus); alert("Error: " + errorThrown);

                        $('#loading-builderlogo').addClass('d-none');
                    }
                });
            });

            $('#buttonSendMarketingCollateral').click(function (e) {
                e.preventDefault();

                var data = new FormData();
                data.append("loan-number", $("#loan-number").val());
                data.append("builder-email", $("#builder-email").val());
                $.ajax({
                    url: window.location.origin + window.location.pathname + '/send-marketing-collateral',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        if (response.success) {
                            alert("Email sent successfully!")

                            return;
                        }
                    }
                });
            });

            $('#new_sales_price').on('focus', function (e) {
                if ($(this).val() === '$0') {
                    $(this).val('');
                }
            });

            $('#new_sales_price').on('keyup change', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var filteredValue = $(this).val().replace(/\D/g, '');
                if (!filteredValue) {
                    $(this).val('$0');
                    return;
                }

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));
                var newValue = Number(filteredValue);
                $(this).val(newValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }));

                if (Math.abs(1 - newValue / curValue) < 0.25) {
                    $('#update_price').prop("disabled", false);
                }
                else
                    console.log('current diff: ' + Math.abs(1 - newValue / curValue));
            });

            $('#new_sales_price').on('blur', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var newValue = Number($('#new_sales_price').val().replace(/\D/g, ''));
                if (newValue == 0)
                    return;

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));

                console.log('price diff: ' + Math.abs(1 - newValue / curValue));
                if (Math.abs(1 - newValue / curValue) > 0.25) {
                    $('#price_error_message').removeClass('d-none');
                    $('#update_price').prop("disabled", true);
                }
                else {
                    $('#price_error_message').addClass('d-none');
                    $('#update_price').prop("disabled", false);
                }
            });

            $('#update_price, #revert_original_price').on('click', function (e) {
                $('#price_change_form').parent().addClass('d-none');
                $('#loading-img-price').removeClass('d-none');

                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_price'
                    ? `update-price?loanNumber=${confirmationNumber}&newPrice=${Number($('#new_sales_price').val().replace(/\D/g, ''))}`
                    : `update-price?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        if (data == 'no data') {
                            $('#update_price_error_message').removeClass('d-none');
                        }
                        if (data == 'no rates') {
                            $('#no_rates_message').removeClass('d-none');
                        }
                        else
                            location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#update_price_error_message').removeClass('d-none');

                        $('#price_change_form').parent().removeClass('d-none');
                        $('#loading-img-price').addClass('d-none');
                    });
            });

            $('#new_concession').on('keyup change blur', function (e) {
                $('#concession_error_message').addClass('d-none');
                $('#concession_update_error_message').addClass('d-none');

                var value = Number($(this).val());
                if (value >= 0.5 && value <= 6) {
                    $('#update_builder_concession').prop("disabled", false);
                }
                else {
                    $('#update_builder_concession').prop("disabled", true);
                    $('#concession_error_message').removeClass('d-none');
                }
            });

            $('#update_builder_concession').on('click', function (e) {
                $('#concession_change_form').parent().addClass('d-none');
                $('#loading-img-concession').removeClass('d-none');

                $('#concession_error_message').addClass('d-none');
                $('#concession_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_builder_concession'
                    ? `update-builder-concession?loanNumber=${confirmationNumber}&newConcession=${Number($('#new_concession').val())}`
                    : `update-builder-concession?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#concession_update_error_message').removeClass('d-none');

                        $('#concession_change_form').parent().removeClass('d-none');
                        $('#loading-img-concession').addClass('d-none');
                    });
            });

            $('#update_credit').on('click', function (e) {
                $('#credit_change_form').parent().addClass('d-none');
                $('#loading-img-credit').removeClass('d-none');

                $('#credit_error_message').addClass('d-none');
                $('#credit_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_credit'
                    ? `update-credit?loanNumber=${confirmationNumber}&newCredit=${Number($('#new_credit').val())}&newCreditGov=${Number($('#new_credit_gov').val())}`
                    : `update-credit?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#credit_update_error_message').removeClass('d-none');

                        $('#credit_change_form').parent().removeClass('d-none');
                        $('#loading-img-credit').addClass('d-none');
                    });
            });

            $('#new_credit').on('keyup change blur', function (e) {
                $('#credit_error_message').addClass('d-none');
                $('#credit_update_error_message').addClass('d-none');
                var maxValue = Number($('#maxValue').val());
                var value = Number($(this).val());
                if (value >= 0 && value <= maxValue) {
                    var value1 = Number($('#new_credit_gov').val());
                    if (value1 >= 0 && value1 <= maxValue) {
                        $('#update_credit').prop("disabled", false);
                    }
                }
                else {
                    $('#update_credit').prop("disabled", true);
                    $('#credit_error_message').removeClass('d-none');
                }
            });

            $('#new_credit_gov').on('keyup change blur', function (e) {
                $('#credit_error_message').addClass('d-none');
                $('#credit_update_error_message').addClass('d-none');
                var maxValue = Number($('#maxValue').val());
                var value = Number($(this).val());
                if (value >= 0 && value <= maxValue) {
                    var value1 = Number($('#new_credit').val());
                    if (value1 >= 0 && value1 <= maxValue) {
                        $('#update_credit').prop("disabled", false);
                    }
                }
                else {
                    $('#update_credit').prop("disabled", true);
                    $('#credit_error_message').removeClass('d-none');
                }
            });

            $('#update_property_street').on('click', function (e) {
                var streetNumber = $('#new_streetnumber').val();
                var streetName = $('#new_streetname').val();

                if (!streetNumber.length || !streetName.length) {
                    $('#street_error_message').text('Please enter a valid street number and name').removeClass('d-none');
                    return;
                }

                $('#street_change_form').parent().addClass('d-none');
                $('#loading-img-street-change').removeClass('d-none');

                $('#street_error_message').addClass('d-none');
                $('#street_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_property_street'
                    ? `update-property-street?loanNumber=${confirmationNumber}&newStreetNumber=${$('#new_streetnumber').val()}&newStreetName=${$('#new_streetname').val()}`
                    : `update-property-street?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#street_update_error_message').removeClass('d-none');

                        $('#street_change_form').parent().removeClass('d-none');
                        $('#loading-img-street-change').addClass('d-none');
                    });
            });

            $('#update_builderinfo').on('click', function (e) {
                var companyName = $('#new_builder_companyname').val();
                var phoneNumber = $('#new_builder_phonenumber').val();
                var email = $('#new_builder_email').val();

                if (!companyName.length || !phoneNumber.length || !email.length) {
                    $('#builderinfo_error_message').text('Please enter valid builder information').removeClass('d-none');
                    return;
                }

                $('#builderinfo_change_form').parent().addClass('d-none');
                $('#loading-img-builderinfo-change').removeClass('d-none');

                $('#builderinfo_error_message').addClass('d-none');
                $('#builderinfo_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();
                                         
                $.post({
                    url: "update-builder-info?confirmation=" + $('#hdnConfirmationNumber').val(),
                    data: { companyName, phoneNumber, email },                    
                })
                .done(function (data, textStatus, jqXHR) {
                    location.reload();
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    $('#builderinfo_update_error_message').removeClass('d-none');
                    $('#builderinfo_change_form').parent().removeClass('d-none');
                    $('#loading-img-builderinfo-change').addClass('d-none');
                });
            });  

            $('#update_featured').click(function (e) {
                e.preventDefault();
                var confirmationNumber = $('#hdnConfirmationNumber').val();

                $("#loading-img-featured").removeClass("d-none");
                $('#featured_update_error_message').removeClass('d-none');
                $('#featured_rate_form').parent().addClass('d-none');
                var postUrl = $(this).attr('id') == 'update_featured'
                    ? `update-featured?loanNumber=${confirmationNumber}&loanprogram=${$("#new-loanprogram").val()}&downpayment=${$("#new-downpayment option:selected").val()}&ficoscore=${$("#new-fico option:selected").text()}&lockrate=${$("#new-fico option:selected").val()}&programCode=${$("#hdnloanprogramcode").val()}`
                    : `update-featured?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        $("#loading-img-featured").addClass("d-none");
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#featured_update_error_message').removeClass('d-none');
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });
            });

            $('#revert_featured').click(function (e) {
                e.preventDefault();
                var confirmationNumber = $('#hdnConfirmationNumber').val();

                $("#loading-img-featured").removeClass("d-none");
                $('#featured_update_error_message').addClass('d-none');
                $('#featured_rate_form').parent().addClass('d-none');
                var postUrl = $(this).attr('id') == 'revert_featured'
                    ? `revert-featured?loanNumber=${confirmationNumber}`
                    : `revert-featured?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#featured_update_error_message').removeClass('d-none');
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });

                $("#loading-img-featured").addClass("d-none");
            });

            $('[data-programs] input').on('change', function (e) {
                $('#update_programs').prop('disabled', false);
            });

            $('#update_programs').on('click', function (e) {
                $('#loading-img-programs').removeClass('d-none');
                $('#update_programs_error_message').addClass('d-none');
                $('[data-programs]').parent().addClass('d-none');

                var programList = [];
                $('[data-programs] input:checked').each(function () {
                    programList.push($(this).val());
                });

                var confirmation = $('#hdnConfirmationNumber').val();

                $.ajax({
                    url: location.origin + location.pathname.replace('confirmation', 'update-program-list?confirmationNumber=') + confirmation,
                    type: 'POST',
                    contentType: 'text/plain',
                    data: programList.join(','),
                    success: function (response) {
                        location.reload();
                    }
                }).done(function (data, textStatus, jqXHR) {
                    location.reload();
                })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#update_programs_error_message').removeClass('d-none');
                        $('#loading-img-programs').addClass('d-none');
                        $('[data-programs]').parent().removeClass('d-none');
                    });
            });

            if ($('#property_video').is('.pending')) {
                var propertyVideoStatusCheckCounter = 0;

                var timer = setInterval(() => {
                    $.get("/lock-products/video-upload-status?confirmationNumber=" + $('#hdnConfirmationNumber').val() + "&videoType=custom")
                        .done(function (data, textStatus, jqXHR) {
                            if (data.videoUrl && data.videoUrl.length > 0) {
                                propertyVideoStatusCheckCounter = builderSpecVideoGenerationTimeout;

                                $('#property_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#property_video [data-role="play-button"]').prop('href', data.videoUrl);
                                $('#property_video').removeClass('pending');
                                $('#property_video_loading').addClass('d-none');
                                new VideoPlayer();

                                $('[download="CustomVideo"]').prop('href', data.videoFile);
                                $('[download="CustomVideo"]').parent().removeClass('d-none');

                                $('#property_video_qr').removeClass('d-none');
                                $('#property_video_qr_loading').addClass('d-none');

                                $('[download="VideoQRCode"]').prop('href', data.qrFile);
                                $('[download="VideoQRCode"]').parent().removeClass('d-none');

                                $('#instructions-div').addClass('d-none');
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            propertyVideoStatusCheckCounter = builderSpecVideoGenerationTimeout;
                        })
                        .always(function () {
                            propertyVideoStatusCheckCounter++;

                            if (propertyVideoStatusCheckCounter > builderSpecVideoGenerationTimeout) {
                                $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                                clearInterval(timer);
                            }
                        });
                }, 2000);
            }

            if ($('#educational_video').is('.pending')) {
                var socialVideoStatusCheckCounter = 0;

                var timer1 = setInterval(() => {
                    $.get("/lock-products/video-upload-status?confirmationNumber=" + $('#hdnConfirmationNumber').val() + "&videoType=social")
                        .done(function (data, textStatus, jqXHR) {
                            if (data.videoUrl && data.videoUrl.length > 0) {
                                socialVideoStatusCheckCounter = builderSpecVideoGenerationTimeout;

                                $('#educational_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#educational_video [data-role="play-button"]').prop('href', data.videoUrl);
                                $('#educational_video').removeClass('pending');
                                $('#educational_video_loading').addClass('d-none');
                                new VideoPlayer();

                                $('[download="CustomVideo1"]').prop('href', data.videoFile);
                                $('[download="CustomVideo1"]').parent().removeClass('d-none');

                                $('#instructions-edu-div').addClass('d-none');
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            socialVideoStatusCheckCounter = builderSpecVideoGenerationTimeout;
                        })
                        .always(function () {
                            socialVideoStatusCheckCounter++;

                            if (socialVideoStatusCheckCounter > builderSpecVideoGenerationTimeout) {
                                $('#instructions-edu-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                                clearInterval(timer1);
                            }
                        });
                }, 2000);
            }

            if ($('#reorder_signrider').length) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap2';
                script.async = true;
                document.body.appendChild(script);

                $('[data-toggle="tooltip"]').tooltip();

                $('#reorder_signrider').on('click', function () {
                    $('#signrider_reorder_dialog').addClass('show');
                });

                $('#signrider_newaddress').on('change', function () {
                    $('#signrider_address_form').toggleClass('active');
                    $('.pac-container').css('z-index', '10001');
                });

                $('#cancel_reorder').on('click', function () {
                    $('#address_form_error, #signrider_order_error').addClass('d-none');

                    $('#street_number').val('');
                    $('#route').val('');
                    $('#locality').val('');
                    $('#administrative_area_level_1').val('');
                    $('#postal_code').val('');

                    $('#signrider_reorder_dialog').removeClass('show');

                    $("#signrider_newaddress").prop("checked", false);
                    $('#signrider_address_form').removeClass('active');
                });

                $('#confirm_reorder').on('click', function () {
                    $('#signrider_order_error').addClass('d-none');

                    if ($('#signrider_newaddress').is(':checked')) {
                        var streetNumber = $('#street_number').val();
                        var streetName = $('#route').val();
                        var city = $('#locality').val();
                        var state = $('#administrative_area_level_1').val();
                        var zip = $('#postal_code').val();

                        if (!streetNumber.length || !streetName.length || !city.length || !state.length || !zip.length) {
                            $('#address_form_error').text('Please enter a valid shipping address').removeClass('d-none');
                            return;
                        }
                    }

                    $.post({
                        url: "reorder-yard-sign?confirmation=" + $('#hdnConfirmationNumber').val(),
                        data: { streetNumber, streetName, city, state, zip },
                        beforeSend: function () {
                            $('.dialog-content, .dialog-buttons').addClass('d-none');
                            $('.dialog-loading').removeClass('d-none');
                        }
                    })
                        .done(function () {
                            $('#success_message, #close_reorder').removeClass('d-none');
                            $('#cancel_reorder, #confirm_reorder').addClass('d-none');
                            $('.dialog-content').children().not('#success_message').addClass('d-none');
                        })
                        .fail(function () {
                            $('#address_error').removeClass('d-none');
                            $('#signrider_order_error').removeClass('d-none').children().first().text('Unable to place new sign rider order. Please try again.');
                        })
                        .always(function () {
                            $('.dialog-content, .dialog-buttons').removeClass('d-none');
                            $('.dialog-loading').addClass('d-none');
                        });
                });

                $('#autocomplete').bind("cut copy paste", function (e) {
                    e.preventDefault();
                });

                $('#close_reorder').on('click', function () {
                    $('#signrider_reorder_dialog').removeClass('show');
                    $('#reorder_signrider').parent().addClass('d-none');
                });
            }
        });
    }
});